import React from 'react';
import { withTranslation } from 'config/i18n';
import { useLayoutState } from 'components/shared/Layout';
import ContactUsContent from 'common/components/ContactUsDialog/ContactUsContent';
import {
  Grid,
  Box,
  Typography,
  Container, makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    paddingTop: theme.spacing(6),
    backgroundColor: theme.palette.common.white,
  },
  title: {
    marginBottom: theme.spacing(4),
    fontWeight: 'bold',
  },
}));

const ListYourBike = ({ t, er }) => {
  const classes = useStyles();
  const { layoutState } = useLayoutState();

  return (
    <>
      <Box className={classes.mainContainer}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h3" className={classes.title}>
                {er
                  ? t('fe_es_layout:contact_us_help.contact_eaglerider')
                  : t('fe_es_layout:contact_us_help.contact_eagleShare')}
              </Typography>
              <ContactUsContent
                er={er}
                userId={
                  layoutState.current_user ? layoutState.current_user.id : null
                }
                isContactUsPage
                caseParam="eagleshare"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default withTranslation([
  'fe_es_layout',
])(ListYourBike);
